import React from 'react';

function SiteFooter() {
  return (
    <footer
      id="site-footer"
      className="c-site-footer c-site-footer@tablet c-site-footer@desktop c-site-footer@wide"
    >
      <div className="bow">
        <div className="container">
          <div className="row">
            <div className="col-md1-12">
              <ul className=" c-site-footernav list-unstyled">
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">Contact us</span>
                  </a>
                </li>
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">Leave feedback</span>
                  </a>
                </li>
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">
                      Schedule an appointment
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md1-12">
              <ul className="c-site-footernav list-unstyled">
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">
                      Frequently asked questions
                    </span>
                  </a>
                </li>
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">
                      Security &amp; privacy
                    </span>
                  </a>
                </li>
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">
                      Debt management advice
                    </span>
                  </a>
                </li>
                <li className="c-link">
                  <a href="">
                    <span className="c-link__title">
                      Terms &amp; conditions
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
